import {
    googleSheetApiSupport
} from "../../../Vendor/Google/Support/GoogleSheetApiSupport";

/***
 * 取得 google sheet 各主題文章推薦資訊
 */
export async function getThemeBlogDetailSupport(spread_id, response_result) {
    let theme_blog_detail_list = [];
    for (let i = 0; i < response_result.length; i++) {
        theme_blog_detail_list[i] = await googleSheetApiSupport(spread_id, response_result[i].theme_blog_sheet_id);
    }
    return theme_blog_detail_list;
}